import { useEffect, useRef, useState } from 'react';

import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(...registerables, ChartDataLabels);

export const BarChartWithLegend = ({ data, chartTitle = 'Técnicos' }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const [totalQuantity, setTotalQuantity] = useState(0);

  useEffect(() => {
    if (!chartRef.current) return;
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }
    const sortedData = [...(data || [])].sort((a, b) => b.count - a.count);
    const labelsStatus = sortedData.map((item) => item.username);
    const quantities = sortedData.map((item) => item.count);
    const ctx = chartRef.current.getContext('2d');
    if (!ctx) return;
    chartInstance.current = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labelsStatus,
        datasets: [
          {
            label: 'Quantidade',
            data: quantities,
            backgroundColor: [
              '#fd65a0',
              'rgba(119, 205, 255, 1)',
              '#736558',
              'rgba(211, 211, 211, 1)',
              'rgba(176, 136, 255, 1)',
              'rgba(153, 230, 255, 1)',
              'rgba(255, 249, 230, 1)',
              'rgba(232, 232, 232, 1)',
              'rgba(75, 148, 214, 1)',
              'rgba(255, 229, 180, 1)',
              'rgba(158, 158, 158, 1)',
              'rgba(255, 182, 193, 1)',
              'rgba(173, 216, 230, 1)',
              'rgba(255, 218, 185, 1)',
              'rgba(152, 251, 152, 1)',
              'rgba(240, 230, 140, 1)',
              'rgba(175, 238, 238, 1)',
              'rgba(255, 160, 122, 1)',
              'rgba(216, 191, 216, 1)',
              'rgba(255, 250, 205, 1)',
              'rgba(250, 235, 215, 1)',
              'rgba(127, 255, 212, 1)',
              'rgba(255, 105, 180, 1)',
              'rgba(0, 191, 255, 1)',
              'rgba(60, 179, 113, 1)',
              'rgba(255, 215, 0, 1)',
            ],
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'top',
            labels: {
              boxWidth: 30,
              padding: 15,
              font: {
                size: 18,
                weight: 'bold',
              },
            },
            title: {
              display: true,
              text: chartTitle,
              font: {
                size: 30,
                weight: 'bold',
              },
            },
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const label = context.label || '';
                const value = context.raw;
                const total = context.dataset.data.reduce((a, b) => a + b, 0);
                const percentage = Math.round((value / total) * 100);
                return `${label}: ${value} (${percentage}%)`;
              },
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'top',
            font: {
              weight: 'bold',
              size: 14,
            },
            color: 'black',
          },
        },
      },
    });
    const totalValue = quantities.reduce((a, b) => a + b, 0);
    setTotalQuantity(totalValue);
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data, chartTitle]);

  return (
    <div style={{ width: '100%', height: '400px', marginTop: '3rem', position: 'relative' }}>
      <canvas ref={chartRef} />
      {totalQuantity > 0 && (
        <div style={{ position: 'absolute', right: 20, top: 20, fontWeight: 'bold' }}>
          Total: {totalQuantity}
        </div>
      )}
    </div>
  );
};
export default BarChartWithLegend;
